import {
    Directive,
    ElementRef,
    Injector,
    Input,
    OnChanges,
    SimpleChanges,
    afterNextRender,
} from '@angular/core';

const staggerStepMs = 50;
const cardClasses = ['flipping-card-enter', 'vertical-flipping-card-enter'];

/**
 * Staggers the flip-in of a grid's cards (children with `flipping-card-enter`
 * or `vertical-flipping-card-enter`) by 50ms per card position, but only for
 * cards created in the render right after the bound value changes, e.g.
 * `[appCardStagger]="items.length"`. Cards that enter while the value is
 * unchanged, such as a reload with the same count, flip in together.
 */
@Directive({
    selector: '[appCardStagger]',
    standalone: false,
})
export class CardStaggerDirective implements OnChanges {
    @Input() public appCardStagger: unknown;

    public constructor(
        private el: ElementRef<HTMLElement>,
        private injector: Injector
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        // On the first change the grid was just created, so every card is
        // entering, including static ones Angular created before the inputs.
        const existing = new Set(
            changes['appCardStagger'].firstChange
                ? []
                : Array.from(this.el.nativeElement.children)
        );

        // Runs after the cards render and before the browser starts their
        // animations, so the delay applies to this entrance only.
        afterNextRender(
            () => {
                const cards = Array.from(this.el.nativeElement.children).filter(
                    child => cardClasses.some(c => child.classList.contains(c))
                ) as HTMLElement[];

                cards.forEach((card, position) => {
                    if (!existing.has(card)) {
                        card.style.animationDelay = `${position * staggerStepMs}ms`;
                    }
                });
            },
            { injector: this.injector }
        );
    }
}
